<template lang="pug">
  .profile-page__main
    .profile-page__body
      section.profile-page-form__section.profile-section
        .profile-section__title
          h2.profile-section-title Распорядок дня
        .profile-section__body
          .form
            .form__elem.form__elem_full
              manager-shift-editor-copy-form-data(
              v-if="otherShifts.length > 0"
              :options="otherShifts"
              :current-data="fields"
              :current-shift="shiftData"
              @update-field="updateField"
              @cancel-update-field="cancelUpdateField"
              )
            .form__elem(
              v-for="item in fields.scheduleItems"
            )
              .form-elem
                .form-elem__body
                  .schedule
                    .schedule__time
                      input.input.input_full(
                      v-model="item.time"
                      )
                    .schedule__text
                      input.input.input_full(
                      v-model="item.text"
                      )
            .form__elem
              .form-elem.form-elem_right
                .form-elem__title
                .form-elem__body
                  button.button.button_paint-main--light.button_narrow(
                  @click.prevent="onAddItem"
                  )
                    .button__text Добавить пункт
      section.profile-page-form__section.profile-section
        .profile-section__body
          .form
            .form__elem.form__elem_button
              .form-elem
                .form-elem__body
                  button.button.button_paint-main.button_long(
                  @click.prevent="onSaveCamp()"
                  )
                    .button__text Сохранить
                .form-elem__error(
                v-if="currentErrorMessage.length > 0"
                ) {{currentErrorMessage}}

</template>

<script>

import ManagerShiftEditorCopyFormData from "./components/ManagerShiftEditorCopyFormData";
export default {
  name: "ManagerShiftEditorSchedule",
  components: {ManagerShiftEditorCopyFormData},
  props: {
    currentErrorMessage: {
      type: String,
      default: ""
    },
    errors: {
      type: Object,
      default: () => ({})
    },
    shiftData: {
      type: Object,
      default: () => ({})
    },
    otherShifts: {
      type: Array,
      default: () => ([])
    }
  },
  data() {
    return {
      fields: {
        scheduleItems: [
          {
            time: "",
            text: ""
          }
        ]
      }
    };
  },
  methods: {
    ScheduleItem() {
      this.time = "";
      this.text = "";
    },
    setFields(data) {
      let arr = data.schedule.split(";");
      arr = arr.map(item => {
        return item.split("&");
      });
      const scheduleItems = [];
      arr.forEach(item => {
        scheduleItems.push({
          time: item[0],
          text: item[1]
        });
      });
      this.fields.scheduleItems = scheduleItems;
    },
    onAddItem() {
      this.fields.scheduleItems.push(new this.ScheduleItem());
    },
    onSaveCamp() {
      const completedFields = this.fields.scheduleItems.filter(item => {
        if (item.time.length > 0 || item.text.length > 0) {
          return item;
        }
      });
      if (completedFields.length > 0) {
        this.fields.scheduleItems = completedFields;
      }
      const arr = completedFields.map(item => {
        return item.time + "&" + item.text;
      });
      const data = {
        schedule: arr.join(";")
      };
      this.$emit("on-save-shift", data);
    },

    updateField(data) {
      this.setFields(data);
    },
    cancelUpdateField(data) {
      for (const key in data) {
        this.fields[key] = data[key];
      }
    }
  },
  watch: {
    shiftData(val) {
      this.setFields(val);
    }
  },
  mounted() {
    if (this.shiftData) {
      this.setFields(this.shiftData);
    }
  }
};
</script>
